module.exports = __webpack_public_path__ + "static/media/popular-4.3305cc75.svg";